import { StringUtil } from '@nomidio/common';

export enum UserStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Pending = 'PENDING',
}

export function UserStatusPresentation(userStatus: UserStatus): string {
  switch (userStatus) {
    case UserStatus.Disabled:
      return 'Disabled';
    case UserStatus.Pending:
      return 'Not Registered';
    case UserStatus.Active:
      return 'Registered';
    default:
      console.warn(`Mapping not handled for status '${userStatus}' falling back to value`);
      return StringUtil.toPresentationFormat(userStatus);
  }
}
